import { useEffect, useState } from 'react'

import { Progress } from '@/components/ui/progress'
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastIcon,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast'
import { useToast } from '@/hooks/use-toast'

type ProgressTimerProps = {
  duration: number
}

const ProgressTimer = ({ duration }: ProgressTimerProps) => {
  const [value, setValue] = useState(0)

  useEffect(() => {
    const startTime = Date.now()

    const updateProgress = () => {
      const elapsed = Date.now() - startTime
      const progress = (elapsed / duration) * 100
      setValue(progress <= 100 ? progress : 100)

      if (progress < 100) {
        requestAnimationFrame(updateProgress)
      }
    }

    updateProgress()

    return () => setValue(0)
  }, [duration])

  return <Progress className="absolute bottom-0 left-0 h-1" value={value} />
}

export const Toaster = () => {
  const { toasts } = useToast()

  return (
    <ToastProvider
      label="Notificações"
      swipeDirection="down"
      swipeThreshold={25}
    >
      {toasts.map(
        ({ id, icon, title, description, action, duration, ...props }) => (
          <Toast key={id} {...props}>
            <div className="flex items-center gap-2">
              <ToastIcon>{icon}</ToastIcon>

              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}

                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>

              <ProgressTimer duration={duration ?? 5000} />
            </div>

            {action || <ToastClose />}
          </Toast>
        ),
      )}
      <ToastViewport />
    </ToastProvider>
  )
}
